import { TransactionData } from '../../domain/stream/transaction/TransactionDomains';
import { CaseSettings } from '../../domain/case/CaseDomains';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { CaseActions } from '../actions/CaseActions';
import { ColumnProps } from 'primereact/column';

export interface CaseState {
  transactionData: TransactionData | null;
  historicalData: TransactionData[];
  currentSettings: CaseSettings | null;
  caseSettings: CaseSettings[];
  transactionDataLoading: boolean;
  tableAttributes: Record<string, any>;
  columns: Record<string, ColumnProps[]>;
  transactionContainerLoading: boolean;
  transactionListComponentLoading: boolean;
  transactionListDataLoading: boolean;
  transactionCountLoading: boolean;
}

const initialState: CaseState = {
  transactionData: null,
  historicalData: [],
  currentSettings: null,
  caseSettings: [],
  transactionDataLoading: false,
  tableAttributes: {},
  columns: {},
  transactionContainerLoading: true,
  transactionListComponentLoading: true,
  transactionListDataLoading: true,
  transactionCountLoading: true,
};

export const caseReducer = (state: CaseState = initialState, action: ReduxBaseAction<any, CaseActions>) => {
  switch (action.type) {
    case 'CHANGE_CURRENT_TRANSACTION_DATA':
      return { ...state, transactionData: action.payload };
    case 'CHANGE_CURRENT_CASE_SETTINGS':
      return { ...state, settings: action.payload };
    case 'CHANGE_TRANSACTION_HISTORY_DATA':
      return { ...state, historicalData: action.payload };
    case 'CHANGE_CASE_COLUMNS':
      return { ...state, columns: action.payload };
    case 'CHANGE_CASE_SETTINGS':
      return { ...state, caseSettings: action.payload };
    case 'CHANGE_CASE_DATA_LOADING':
      return { ...state, transactionDataLoading: action.payload };
    case 'CHANGE_CONTAINER_LOADING':
      return { ...state, transactionContainerLoading: action.payload };
    case 'CHANGE_LIST_COMPONENT_LOADING':
      return { ...state, transactionListComponentLoading: action.payload };
    case 'CHANGE_LIST_DATA_LOADING':
      return { ...state, transactionListDataLoading: action.payload };
    case 'CHANGE_TRANSACTION_COUNT_LOADING':
      return { ...state, transactionCountLoading: action.payload };
    case 'CLEAR_TRANSACTION_PAGE':
      return {
        transactionData: null,
        historicalData: [],
        currentSettings: null,
        caseSettings: [],
        transactionDataLoading: false,
        tableAttributes: {},
        columns: [],
      };
    default:
      return state;
  }
};
